import { render, staticRenderFns } from "./CardPropertyDocuments.vue?vue&type=template&id=555789f0&scoped=true&"
import script from "./CardPropertyDocuments.vue?vue&type=script&lang=js&"
export * from "./CardPropertyDocuments.vue?vue&type=script&lang=js&"
import style0 from "./CardPropertyDocuments.vue?vue&type=style&index=0&id=555789f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555789f0",
  null
  
)

export default component.exports
import {QExpansionItem,QItemSection,QSpinner,QBtn,QTooltip,QField} from 'quasar'
component.options.components = Object.assign({QExpansionItem,QItemSection,QSpinner,QBtn,QTooltip,QField}, component.options.components || {})
